import { useEffect } from "react";

import { useExperiment, useExperiments } from "@hopper-b2b/experiments";
import type { Slots } from "@hopper-b2b/ui";
import type { FeatureFlagsContextProps } from "@hopper-b2b/utilities";
import type { Theme } from "@material-ui/core";

import { FEATURE_FLAGS } from "../../App";
import {
  buildCommerceAirHomeUrl,
  buildCommerceAirShopEntryUrl,
} from "../../utils/commercePlatformRedirect";
import FlightsRouteComponent from "./FlightsRouteComponent";
import { RedirectLoader } from "./RedirectLoader";

type FlightSearchRouteProps = {
  theme: Theme;
  featureFlags: FeatureFlagsContextProps;
  slots: Slots;
  entryPoint?: "search" | "shop";
};

export const FlightSearchRoute = ({
  theme,
  featureFlags,
  slots,
  entryPoint = "search",
}: FlightSearchRouteProps) => {
  const forceCommerceRedirect =
    import.meta.env.VITE_FORCE_COMMERCE_FLIGHTS_REDIRECT === "true";

  const experimentBasedRedirect = useExperiment(
    FEATURE_FLAGS.COMMERCE_PLATFORM_FLIGHTS_ROLLOUT
  );
  const externalTripsListEnabled = useExperiment(
    FEATURE_FLAGS.EXTERNAL_TRIPS_LIST
  );

  const commercePlatformEnabled =
    forceCommerceRedirect || experimentBasedRedirect;

  const { isFetched: experimentsFetched = false } = useExperiments();

  useEffect(() => {
    if (experimentsFetched && commercePlatformEnabled === true) {
      const currentParams = new URLSearchParams(window.location.search);
      const buildRedirectUrl =
        entryPoint === "shop"
          ? buildCommerceAirShopEntryUrl
          : buildCommerceAirHomeUrl;
      window.location.replace(
        buildRedirectUrl(currentParams, externalTripsListEnabled === true)
      );
    }
  }, [
    commercePlatformEnabled,
    entryPoint,
    experimentsFetched,
    externalTripsListEnabled,
  ]);

  const showLoader = !experimentsFetched || commercePlatformEnabled;
  if (showLoader) {
    return <RedirectLoader />;
  }

  return (
    <FlightsRouteComponent
      theme={theme}
      featureFlags={featureFlags}
      slots={slots}
    />
  );
};

export default FlightSearchRoute;
